import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export enum formNamesEnum {
  ONE_TO_ONE = 'one_to_one',
  ONE_TO_GROUP = 'one_to_group',
  TOUR = 'tour',
}

interface FormState {
  [formNamesEnum.ONE_TO_ONE]: Record<string, any>;
  [formNamesEnum.ONE_TO_GROUP]: Record<string, any>;
  [formNamesEnum.TOUR]: Record<string, any>;
  [key: string]: Record<string, any>; // Index signature for string indexing
}

const initialState: FormState = {
  one_to_one: {},
  one_to_group: {},
  tour: {},
  errors: {},
};

const formSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    updateField: (
      state,
      action: PayloadAction<{ formName: string; newData: Record<string, any> }>
    ) => {
      const { formName, newData } = action.payload;
      state[formName] = { ...state[formName], ...newData };
    },
    clearForm: (state, action: PayloadAction<string>) => {
      const formName = action.payload;
      state[formName] = {};
    },
    setEventFormErrors: (
      state,
      action: PayloadAction<{ errors: Record<string, any> }>
    ) => {
      const { errors } = action.payload;
      state.errors = errors;
    },
    clearEventFormError: (
      state,
      action: PayloadAction<{ errorName: string }>
    ) => {
      const { errorName } = action.payload;
      delete state.errors[errorName];
    },
  },
});

export const {
  updateField,
  clearForm,
  setEventFormErrors,
  clearEventFormError,
} = formSlice.actions;
export const getEventForm = (state: RootState) => state.formSlice;
export const getFormData = (formName: string) => (state: RootState) =>
  state.formSlice[formName];
export const getEventErrors = (state: RootState) => state.formSlice.errors;

export default formSlice.reducer;
